"use strict";

var _ = require("lodash");
var uuid = require("node-uuid");

module.exports = /* @ngInject */ function(
  $log,
  eikonSsoService,
  goldmanSsoService,
  OpenfinWindowFactory,
  openFinWindowUtils
) {
  var that = this;

  var isFirstTime = true;

  that.setEikonCookies = function(rediWindow) {
    var set = function() {
      return setEikonCookies(rediWindow);
    };

    if (isFirstTime) {
      /*
       * Setting Eikon cookies fails if
       *
       * - user isn't in amers1 region and
       * - the cookie is set for the first time
       *
       * We don't know the root cause yet.
       *
       * To workaround the issue, if it's the first time it sets Eikon cookies, set it twice.
       * */
      return set().then(set);
    } else {
      return set();
    }
  };

  that.setGoldmanCookies = function(rediWindow) {
    return goldmanSsoService
      .getGoldmanSsoCookie()
      .then(function(cookies) {
        return that.setCookiesOnUrl(rediWindow.getPath(), cookies);
      })
      .then(function() {
        return rediWindow;
      });
  };

  function setEikonCookies(rediWindow) {
    return eikonSsoService
      .getEikonSsoCookie()
      .then(function(cookies) {
        if (rediWindow.getSubDomain()) {
          return that.setCookiesOnUrl(rediWindow.getSubDomain(), cookies);
        } else {
          return cookies;
        }
      })
      .then(function(cookies) {
        return that.setCookiesOnUrl(rediWindow.getPath(), cookies);
      })
      .then(function() {
        isFirstTime = false;
        return rediWindow;
      });
  }

  that.setCookiesOnUrl = function(url, cookies) {
    var openFinWindowName = uuid.v4();
    return OpenfinWindowFactory.createInvisibleOpenfinWindow(
      url,
      openFinWindowName
    )
      .then(function(openFinWindow) {
        return setCookies(openFinWindow, cookies);
      })
      .then(function(openFinWindow) {
        return openFinWindowUtils.close(openFinWindow, true);
      })
      .then(function() {
        return cookies;
      });
  };

  function setCookies(openFinWindow, ssoCookies) {
    var code = "";
    _.forEach(ssoCookies, function(cookie) {
      code += 'document.cookie = "' + cookie.replace(/"/g, "") + '"; ';
    });
    $log.debug("Executing remote javascript: " + code);
    return openFinWindowUtils.executeJavaScript(openFinWindow, code);
  }
};



// WEBPACK FOOTER //
// ./app/business/cookieService.js